import { Bank } from "@interfaces/banks";
import { baseApi } from "./baseApi";
import { ResponsePagination } from "@interfaces/response";

const banksApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getBanks: build.query<Array<Bank>, string>({
            query: (params) => ({
                url: `catalogos/banks?${params}`,
            }),
            transformResponse: (response: ResponsePagination<Bank>) => {
                return response.data.data;
            },
        }),
    }),
});

export const { useLazyGetBanksQuery } = banksApi;
